import { h } from 'preact'
import { formatRelativeTime } from '../beacon-utils.js'
import { t } from '../beacon-i18n.js'

/**
 * ConversationRow — one row in the mixed Email + AI "Korábbi beszélgetések"
 * list. Two visual variants (see plan "Design" section, screenshot 2):
 * email → blue subject + green checkmark + status text
 * ai    → "Utolsó frissítés ..." + message-count badge + sparkle icon
 */
export function ConversationRow({ conversation, onClick }) {
  const isEmail = conversation.type === 'email'

  return (
    <button type="button" class={`beacon-conv-row beacon-conv-row-${conversation.type}`} onClick={onClick}>
      {isEmail ? (
        <div class="beacon-conv-row-main">
          <div class="beacon-conv-row-title-line">
            <i class="bi bi-check-circle-fill beacon-conv-check-icon"></i>
            <span class="beacon-conv-title beacon-conv-title-email">{conversation.title}</span>
          </div>
          <span class="beacon-conv-snippet">{conversation.snippet}</span>
        </div>
      ) : (
        <div class="beacon-conv-row-main">
          <div class="beacon-conv-row-title-line">
            <span class="beacon-conv-updated">{t('support.beacon.conversation_row.updated_prefix', { time: formatRelativeTime(conversation.updated_at) })}</span>
            {conversation.count > 0 && <span class="beacon-conv-count-badge">{conversation.count}</span>}
          </div>
          <span class="beacon-conv-title beacon-conv-title-ai">{conversation.title}</span>
          <span class="beacon-conv-snippet">{conversation.snippet}</span>
          <i class="bi bi-stars beacon-conv-sparkle-icon"></i>
        </div>
      )}
    </button>
  )
}
